var _defs, _path, _use, _use2, _use3, _use4, _use5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-cn",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cn-a",
    fill: "#ff0",
    d: "M-.6.8 0-1 .6.8-1-.3h2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h640v480H0z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn-a",
    width: 30,
    height: 20,
    transform: "matrix(71.9991 0 0 72 120 120)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn-a",
    width: 30,
    height: 20,
    transform: "matrix(-12.33562 -20.5871 20.58684 -12.33577 240.3 48)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn-a",
    width: 30,
    height: 20,
    transform: "matrix(-3.38573 -23.75998 23.75968 -3.38578 288 95.8)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn-a",
    width: 30,
    height: 20,
    transform: "matrix(6.5991 -23.0749 23.0746 6.59919 288 168)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cn-a",
    width: 30,
    height: 20,
    transform: "matrix(14.9991 -18.73557 18.73533 14.99929 240 216)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCn);
export default __webpack_public_path__ + "static/media/cn.d111e109dc5ff72a88f3ba2334180278.svg";
export { ForwardRef as ReactComponent };